// Define the interface for Product Detail Information
export interface IProductDetailInformation {
  productDetailsId ?: string; // Added for API response mapping
  scProductDetailCode: string; // Dropdown field (required)
  scProductDetailCodeDescription: string; // Description for scProductDetailCode dropdown
  scProductDetailUserSpecificTerm: string; // Text field (optional)
}

// Define the interface for API Response
export interface IProductDetailResponse {
  scId: string;
  productDetailsId: string;
  scProductDetailCode: string;
  scProductDetailCodeDescription: string;
  scProductDetailUserSpecificTerm: string;
}

export interface IProductDetailApiResponse {
  response: IProductDetailResponse[];
  no_of_records: number;
}

export const mapProductDetailPayload = (jsonData: any, scId: string) => {
  return {
    scId: scId,
    productDetailsId: jsonData.productDetailsId ,
    scProductDetailCode: jsonData.scProductDetailCode,
    scProductDetailCodeDescription: jsonData.scProductDetailCodeDescription || "",
    scProductDetailUserSpecificTerm: jsonData.scProductDetailUserSpecificTerm || "",
  };
};

export const initialProductDetailInformation: IProductDetailInformation = {
  scProductDetailCode: "",
  scProductDetailCodeDescription: "",
  scProductDetailUserSpecificTerm: "",
};

export const mapProductDetailApiResponseToInitialValues = (response: any) => {
  return {
    productDetailsId : response?.productDetailsId || "",
    scProductDetailCode: response?.scProductDetailCode || "",
    scProductDetailCodeDescription: response?.scProductDetailCodeDescription || "",
    scProductDetailUserSpecificTerm: response?.scProductDetailUserSpecificTerm || "",
  };
};
